/* eslint-disable max-statements */
import React, { useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { Divider } from 'primereact/divider';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { CaHistory } from '../managerTlViewSearch/CaHistory';
import { CaApprovalAction, CaStatusNames, HCRecordsCA } from '../../../utils/typeConstants';
import CreatedTemplateIcon from '../../../assets/TemplateCreatedSuccessIcon.png';
import AskCreateTemplateIcon from '../../../assets/DisputeNotification.png';
import ErrorIcon from '../../../assets/stalledIcon.png';
import WarningIcon from '../../../assets/property_warning.png';
import { CaHcRecord } from '../type';
import {
    useGetCaDocumentsQuery,
    useUpdateCorreciveActionMutation,
} from '../managerTlViewSearch/CaMangerTLView.slice';
import { ControlDialogBox } from '../../../components/controlDialogBox/ControlDialogBox';
import {
    selectCurrentEmpid,
    selectCurrentIsAdmin,
    selectCurrentIsHC,
    selectCurrentUser,
} from '../../../pages/login/authSlice';
import MultiFileViewer from '../../../components/fileUploads/MultiFileViewer';
import DescriptionBox from '../../../components/descriptionBox/DescriptionBox';

interface RecordViewProps {
    type: string;
    caHcRecord: CaHcRecord | undefined;
    setActiveTabIndex: (e: number) => void;
}

export const RecordView = ({ type, caHcRecord, setActiveTabIndex }: RecordViewProps) => {
    const loggedEmpUserName = useSelector(selectCurrentUser);
    const [icon, setIcon] = useState<any>();
    const [employeeNumber, setEmployeeNumber] = useState<any>(null);
    const [askcreateTempDialogVisible, setAskcreateTempDialogVisible] = useState<boolean>(false);
    const [createdSuccessTempdialogVisible, setCreatedSuccessTempdialogVisible] = useState<boolean>(false);
    const [warningMessage, setWarningMessage] = useState<string>('');
    const [successMessage, setSuccessMessage] = useState<string>('');
    const [successHeader, setSuccessHeader] = useState<string>('');
    const [comments, setComments] = useState<string>();
    const [notice, setNotice] = useState<any>('');
    const [UpdateCorrectiveAction] = useUpdateCorreciveActionMutation();
    const loggedUserEmpId = useSelector(selectCurrentEmpid);
    const [viewOnly, setViewOnly] = useState<boolean>(true);
    const isAdmin = useSelector(selectCurrentIsAdmin);
    const isHC = useSelector(selectCurrentIsHC);

    const { data: caDocumentsData, isLoading } = useGetCaDocumentsQuery(
        { correctiveActionId: caHcRecord?.corrective_action_id },
        { skip: !caHcRecord?.corrective_action_id }
    );

    const files = caDocumentsData?.data || [];

    useEffect(() => {
        if (isAdmin || isHC) {
            if (
                !(
                    caHcRecord?.ca_status_name === CaStatusNames.Recalled ||
                    caHcRecord?.ca_status_name === CaStatusNames.Draft
                )
            ) {
                setViewOnly(false);
            }
        } else {
            setViewOnly(true);
        }
        setNotice(caHcRecord?.notice_text?.replace(/\\n/g, '<br>').replace(/\n/g, '<br>').replace('"', ''));
    }, [caHcRecord]);

    useEffect(() => {
        switch (caHcRecord?.ca_status_name) {
            case CaStatusNames.Acknowledged:
            case CaStatusNames.Approved:
            case CaStatusNames.Release:
            case CaStatusNames.AutoClosed:
                setIcon(CreatedTemplateIcon);
                break;
            case CaStatusNames.Rejected:
                setIcon(ErrorIcon);
                break;
            case CaStatusNames.ApprovalPending:
            case CaStatusNames.Draft:
            case CaStatusNames.Recalled:
                setIcon(WarningIcon);
                break;
            default:
                break;
        }

        const employee = {
            employeeNumber: caHcRecord?.employee_number,
        };
        setEmployeeNumber(employee);
    }, [caHcRecord]);

    const askCreateTempDialogFuncMap = {
        askCreateTempDialogBox: setAskcreateTempDialogVisible,
    };
    const onAskCreateTempDialogBoxHide = () => {
        askCreateTempDialogFuncMap.askCreateTempDialogBox(false);
    };
    const handleUpdate = (status: string) => {
        if (status === CaStatusNames.Recalled) {
            setWarningMessage('Are you sure you want to recall this corrective action?');
            setSuccessMessage('Recalled!');
            setSuccessHeader('Corrective action has been succesfully recalled');
        }
        setAskcreateTempDialogVisible(true);
    };

    const handleClickCancel = () => {
        onAskCreateTempDialogBoxHide();
    };

    const handleClickYes = async () => {
        const correctiveActionPayload: any = {
            'corrective_action_id': caHcRecord?.corrective_action_id,
            'employee_number': loggedUserEmpId,
            'ca_approval_action_comment': comments,
            'ca_approval_action_id': CaApprovalAction.Recall,
        };
        onAskCreateTempDialogBoxHide();
        updateCorrectiveAction(correctiveActionPayload);
    };

    const updateCorrectiveAction = (correctiveActionPayload: any) => {
        UpdateCorrectiveAction(correctiveActionPayload)
        .unwrap()
        .then((response: any) => {
            if (response.status) {
                setSuccessHeader('Recalled!');
                setSuccessMessage('The corrective action has been successfully recalled');
                setCreatedSuccessTempdialogVisible(true);
            } else {
                toast.error('Error');
            }
        })
        .then((error: any) => {
            if (error) toast.error('Error');
        });
    };
    const handleClickReturn = () => {
        onCreatedSuccessTempDialogBoxHide();
        setTimeout(() => {
            setActiveTabIndex(HCRecordsCA.Records);
        }, 100);
    };

    const CreatedSuccessfooterTemplate = (
        <div className="row flex justify-content-center ">
            <div className="col-md-6">
                <Button
                    className="btn-primary w-100"
                    onClick={handleClickReturn}
                    label={'Continue'}
                />
            </div>
        </div>
    );
    const createdSuccessTempDialogFuncMap = {
        createdSuccessTempDialogBox: setCreatedSuccessTempdialogVisible,
    };

    const onCreatedSuccessTempDialogBoxHide = () => {
        createdSuccessTempDialogFuncMap.createdSuccessTempDialogBox(false);
    };

    const createFooterTemplate = (
        <div className="row">
            <div className="col-md-2">&nbsp;</div>
            <div className="col-md-4">
                <Button
                    className="btn-secondary w-100"
                    onClick={handleClickCancel}
                    label={'Cancel'}
                />
            </div>
            <div className="col-md-4">
                <Button className="btn-primary w-100" onClick={handleClickYes} label={'Yes'} />
            </div>
            <div className="col-md-2">&nbsp;</div>
        </div>
    );
    const formatText = (text: string) => {
        return text.replaceAll('<br>', '\n');
    };

    const handleCommentsChange = (value: string) => {
        setComments(value);
    };

    return (
        <>
            <h6 className="m-top-30">Recipient Information</h6>
            <div className="row mt-4 pb-2">
                <div className="col-md-3">
                    <div className="content">
                        <label htmlFor="recipientName">Recipient Name</label>
                        <InputText
                            disabled
                            placeholder="Recipient Name"
                            value={caHcRecord ? caHcRecord.employee_name : ''}
                        />
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="content">
                        <label htmlFor="countryId">Country</label>
                        <InputText
                            disabled
                            placeholder="Country"
                            value={caHcRecord ? caHcRecord.country_name : ''}
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="content">
                        <label htmlFor="roleId">Role</label>
                        <InputText
                            placeholder="Role"
                            disabled
                            value={caHcRecord ? caHcRecord.scorecard_role_name : ''}
                        />
                    </div>
                </div>
            </div>
            <Divider />
            <h6 className="m-top-30">Corrective Action Information</h6>
            <div className="row">
                <div className="col-md-3">
                    <div className="content">
                        <label htmlFor="recipientName">Author</label>
                        <InputText
                            disabled
                            value={
                                caHcRecord
                                    ? `${caHcRecord.author_employee_name} (${caHcRecord.author_employee_number})`
                                    : ''
                            }
                        />
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="content">
                        <label htmlFor="countryId">Creation Date</label>
                        <Calendar
                            id="basic"
                            disabled
                            value={caHcRecord ? new Date(caHcRecord.create_date) : ''}
                            showIcon
                            className="custom-calendar mb-4"
                            dateFormat="dd-M-yy"
                        />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-3">
                    <div className="content">
                        <label htmlFor="categegory">Category</label>
                        <InputText
                            id="categegory"
                            disabled
                            value={caHcRecord ? `${caHcRecord?.ca_category_name}` : ''}
                        />
                    </div>
                </div>
                {caHcRecord?.ca_misconduct_id && caHcRecord?.ca_misconduct_name ? (
                    <div className="col-md-3">
                        <div className="content">
                            <label htmlFor="misconduct">Misconduct</label>
                            <InputText
                                id="misconduct"
                                disabled
                                value={caHcRecord ? `${caHcRecord?.ca_misconduct_name}` : ''}
                            />
                        </div>
                    </div>
                ) : (
                    <div className="col-md-3">
                        <div className="content">
                            <label htmlFor="sub-category">Sub Category</label>
                            <InputText
                                id="sub-category"
                                disabled
                                value={caHcRecord ? `${caHcRecord?.ca_subcategory_name}` : ''}
                            />
                        </div>
                    </div>
                )}

                <div className="col-md-3">
                    <div className="content">
                        <label htmlFor="sevierityLevelId">Severity Level</label>
                        <InputText
                            id="sevierityLevelId"
                            disabled
                            value={caHcRecord ? `${caHcRecord?.severity_level_name}` : ''}
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="content">
                        <label htmlFor="empLanguageId">Language*</label>
                        <InputText
                            id="empLanguageId"
                            disabled
                            value={caHcRecord ? `${caHcRecord?.emp_language_name}` : ''}
                        />
                    </div>
                </div>
            </div>

            {type === 'view' && (
                <div className="row">
                    <div className="col-md-3">
                        <h6 className="m-top-30">Status</h6>
                        <div className="status-container">
                            <img className="status-icon" src={icon} alt="icons" />
                            &nbsp;<p className="m-0">{caHcRecord?.ca_status_name}</p>
                        </div>
                    </div>
                    {caHcRecord?.in_training && (
                        <div className="col-md-5" style={{ marginTop: '55px', display: 'flex' }}>
                            <img className="status-icon" src={CreatedTemplateIcon} alt="icons" />
                            <p style={{ marginLeft: '5px' }}>Issued during training</p>
                        </div>
                    )}
                </div>
            )}
            <h6 className="m-top-30">Notice</h6>
            <p style={{ whiteSpace: 'break-spaces' }}>{formatText(notice)}</p>
            {viewOnly && caHcRecord?.recall_comment != null && (
                <>
                    <h6 className="m-top-30">Comments</h6>
                    <p>{caHcRecord?.recall_comment}</p>
                </>
            )}

            <div>
                {caHcRecord?.corrective_action_id &&
                    caHcRecord.corrective_action_id > 0 &&
                    files.length > 0 && <MultiFileViewer files={files} loading={isLoading} />}
            </div>
            {!viewOnly && (
                <div className="flex justify-content-center m-top-15">
                    <DescriptionBox
                        createdByLabel="Author"
                        createdByValue={loggedEmpUserName}
                        title="Comments*"
                        responseDescription={comments}
                        value={comments}
                        limit={4000}
                        onChange={handleCommentsChange}
                    />
                </div>
            )}
            <div className="row button-container">
                {!viewOnly && (
                    <Button
                        type="button"
                        onClick={() => {
                            if (comments) {
                                handleUpdate(CaStatusNames.Recalled);
                            } else {
                                toast.error('Please add comments');
                            }
                        }}
                        className="btn-primary w-120 m-r-20"
                        label="Recall"
                    />
                )}
                <Button
                    type="button"
                    onClick={() => {
                        setActiveTabIndex(HCRecordsCA.Records);
                    }}
                    className="btn-secondary w-200 m-r-20"
                    label="Return to Dashboard"
                />
            </div>
            {caHcRecord && employeeNumber && (
                <CaHistory
                    employeNumber={employeeNumber}
                    caId={caHcRecord?.corrective_action_id}
                    showMisconduct={Boolean(caHcRecord?.ca_misconduct_id && caHcRecord?.ca_misconduct_name)}
                    // caType={'update'}
                />
            )}
            <ControlDialogBox
                dialogVisibile={askcreateTempDialogVisible}
                IconPath={AskCreateTemplateIcon}
                footerTemplate={createFooterTemplate}
                subHeading={''}
                subHeadingColor={'#7D71E2'}
                msgText={warningMessage}
                onDialogBoxHide={onAskCreateTempDialogBoxHide}
            />
            <ControlDialogBox
                dialogVisibile={createdSuccessTempdialogVisible}
                footerTemplate={CreatedSuccessfooterTemplate}
                IconPath={CreatedTemplateIcon}
                subHeading={successHeader}
                subHeadingColor={'#64D96E'}
                msgText={successMessage}
                onDialogBoxHide={onCreatedSuccessTempDialogBoxHide}
            />
        </>
    );
};
